<script lang="ts">
  import { cn } from "@tastyworks/ui-library"
  import type { Snippet } from "svelte"
  import { actionsVariants } from "."

  type Props = {
    alignActions?: "start" | "center" | "end"
    variant?: "horizontal" | "vertical"
    class?: string
    children?: Snippet
  }

  let {
    alignActions = "end",
    variant = "horizontal",
    class: className,
    children,
    ...restProps
  }: Props = $props()
</script>

<div
  class={cn(actionsVariants({ variant }), className)}
  class:justify-start={alignActions === "start"}
  class:justify-center={alignActions === "center"}
  class:justify-end={alignActions === "end"}
  {...restProps}
>
  {@render children?.()}
</div>
